import styled from '@emotion/styled'
import { pxToRemUnit } from 'utils/styled'

export const SAnimatedPhoto = styled.div<{ borderRadius?: number }>`
  overflow: visible;
  width: 100%;
  position: relative;
  & video {
    border-radius: ${(p) => pxToRemUnit(p.borderRadius ?? 2)};
  }
  & img {
    max-width: 40%;
    max-height: 40%;
    object-fit: contain;
    z-index: 2;
    position: absolute;
    bottom: -5%;
    left: -5%;
    border-radius: 2px;
  }
  & div {
    width: 100%;
  }
`
